import { AdminRole } from "@cpg/common";

// ─── Role-gating helper ─────────────────────────────────────────────────────
//
// Shared by the shell's nav (which sections are visible) and, in later
// sub-tasks (14b-14e), by every page's action-gating call sites (create/edit/
// resolve buttons). Mirrors backoffice-api's own RolesGuard semantics
// exactly: SUPERADMIN passes every check regardless of `required`; every
// other role must appear literally in `roles`.

/**
 * True if `roles` grants access to something gated behind any of
 * `required` — either directly (roles includes one of `required`) or via
 * SUPERADMIN, which passes every check. Called with zero `required` roles
 * (e.g. `hasRole(admin.roles)`) means "SUPERADMIN only".
 */
export function hasRole(roles: AdminRole[], ...required: AdminRole[]): boolean {
  if (roles.includes(AdminRole.SUPERADMIN)) return true;
  return required.some((role) => roles.includes(role));
}
